import Circle from '@arcgis/core/geometry/Circle';
import Point from '@arcgis/core/geometry/Point';
import Polygon from '@arcgis/core/geometry/Polygon';
import Polyline from '@arcgis/core/geometry/Polyline';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';
import { DEFAULT_MAP_SOURCE } from '@env';

export class FsDrawing {
  get defaultMapSource(): string {
    return DEFAULT_MAP_SOURCE;
  }

  constructor(public shape: any) {
    switch (this.defaultMapSource) {
      case 'esri':
        this.shape = this._handleEsriShapes(this.shape);
        break;
      case 'google':
        this.shape = this._handleGoogleShapes(this.shape);
        break;
    }
  }

  public getBounds(): Object {
    const nwBound = [this.shape.extent.ymax, this.shape.extent.xmin];
    const seBound = [this.shape.extent.ymin, this.shape.extent.xmax];
    return {
      topLeft: nwBound,
      bottomRight: seBound,
    };
  }

  public getCenter(): Object {
    return {
      latitude: this.shape.extent.center.latitude,
      longitude: this.shape.extent.center.longitude,
    };
  }

  public getBorder(): Object {
    return this.shape.rings;
  }

  public getContains(point: any): boolean {
    return this.shape.contains(point);
  }

  private _handleEsriShapes(shape: Polygon | Circle | Polyline): any {
    return webMercatorUtils.webMercatorToGeographic(shape);
  }

  private _handleGoogleShapes(
    shape: google.maps.Polygon | google.maps.Circle | google.maps.Rectangle,
  ): any {
    if (shape instanceof google.maps.Polygon) {
      const path = shape.getPath().getArray();
      const polygon = new Polygon({
        spatialReference: {
          wkid: 4326,
        },
      });

      const paths = path.map((p) => [p.lng(), p.lat()]);
      polygon.addRing(paths);

      return polygon;
    }
    if (shape instanceof google.maps.Circle) {
      const center = shape.getCenter();
      const radius = shape.getRadius();

      const centerPoint = new Point({
        latitude: center.lat(),
        longitude: center.lng(),
      });

      return new Circle({
        spatialReference: {
          wkid: 4326,
        },
        center: centerPoint,
        radius,
      });
    }
    if (shape instanceof google.maps.Rectangle) {
      const bounds = shape.getBounds();
      const topLeft = [bounds.getSouthWest().lng(), bounds.getNorthEast().lat()];
      const topRight = [bounds.getNorthEast().lng(), bounds.getNorthEast().lat()];
      const bottomLeft = [bounds.getSouthWest().lng(), bounds.getSouthWest().lat()];
      const bottomRight = [bounds.getNorthEast().lng(), bounds.getSouthWest().lat()];
      return new Polygon({
        spatialReference: {
          wkid: 4326,
        },
        rings: [[topLeft, topRight, bottomLeft, bottomRight, topLeft]],
      });
    }
  }
}
